exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout{height:100%}.layout .navbar-logo{width:70px}.layout .bg-blue{background-color:#e3f2fd}.nav-actions{display:flex}.nav-actions .nav-action+.nav-action{margin-left:5px}", ""]);

// exports
